<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-users me-2"></i>Benutzer ({{totalEntries}})</h1>
</div>

<button type="button" class="btn btn-primary mb-3" [routerLink]="['/user', 0]" *ngIf="accessService.hasRight('ADMIN')">Benutzer anlegen</button>

<pagination
        [hidden]="entries?.length == 0"
        [totalItems]="totalEntries"
        [itemsPerPage]="paginConfig.itemsPerPage"
        [(ngModel)]="paginConfig.page"
        (pageChanged)="listEntries($event)"
        [maxSize]="20"
        previousText="Letzte"
        nextText="Nächste">
</pagination>

<div class="table-responsive">
    <table *ngIf="entries?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th style="width: 100px" (click)="setOrder('firstname')">
                Vorname <i class="fas" *ngIf="predicate == 'firstname'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('lastname')">
                Nachname <i class="fas" *ngIf="predicate == 'lastname'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('department')">
                Abteilung <i class="fas" *ngIf="predicate == 'department'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('last_login')">
                Letzter Login <i class="fas" *ngIf="predicate == 'last_login'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('active')">
                Aktiv <i class="fas" *ngIf="predicate == 'active'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/user', entry.id]">
            <td>{{ entry.firstname }}</td>
            <td>{{ entry.lastname }}</td>
            <td>
                {{ entry.department }}
                <span class="text-muted" *ngIf="!entry.department">Nicht gesetzt</span>
            </td>
            <td>
                {{ entry.last_login | date: 'dd.MM.yyyy, HH:mm' }}
                <span class="text-muted" *ngIf="!entry.last_login">Noch nicht angemeldet</span>
            </td>
            <td>{{ entry.active | yesNo }}</td>
        </tr>
        </tbody>
    </table>
</div>
